export const setLoading = (state, payload) => {
  state.loading = payload;
};

export const setError = (state, payload) => {
  state.error = payload;
};

export const setUsuario = (state, payload) => {
  state.usuario = payload;
};

export const setNavbar = (state, payload) => {
  state.navbar = payload;
};

export const setBottons = (state, payload) => {
  state.bottons = payload;
};
